<svelte:options
  customElement={{
    tag: 'information-ticker',
    shadow: "none",
    props: {
      setFilter: { type: 'String' }
    }
  }}
/>
<script>
  import Splide from '@splidejs/splide';
  import '@splidejs/splide/css';
  import { createNewsState } from '@modules/FetchInformation.svelte.js';
  import { tick } from 'svelte';
  const info_yellow = "/assets_default/icons/info_yellow.svg"

  let { setFilter = ""} = $props();

  const filterBizTicker = news => news.businessTicker === 1;
  const filterTopTicker = news => news.serviceTicker === 1;
  const filter = setFilter === 'businessTicker' ? filterBizTicker : filterTopTicker;
  const displayCount = 10;
  const newsState = createNewsState(filter);
  let newsToShow = $derived(newsState.newsList.slice(0, displayCount));
//---

  //splide
  let splideInstance = $state();
  let splideElement;
  // 現在のスライド番号を監視（Splideのイベントを利用）
  let currentIndex = $state(1);

  $effect(() => {
    // splideElement が DOM にマウントされ、表示するニュースがある場合に実行
    if (splideElement && newsToShow.length > 0) {
      console.log("newsToShow"+newsToShow)
      let newSplideInstance;

      // DOMの更新が完了するのを待ってからSplideを初期化
      const initSplide = async () => {
        await tick();
        if (!splideElement) return; // tick後に要素が消えている可能性を考慮

        newSplideInstance = new Splide(splideElement, {
          type: 'loop',
          perPage: 1,
          autoplay: true,
          interval: 5000,
          pauseOnHover: true,
          arrows: false,
          pagination: false,
          speed: 800,
        }).mount();

        newSplideInstance.on('moved', (newIndex) => {
          currentIndex = newIndex + 1;
        });

        splideInstance = newSplideInstance;
      };

      initSplide();

      // クリーンアップ関数
      return () => {
        newSplideInstance?.destroy();
        splideInstance = undefined;
      };
    }
  });
</script>

<div class="owd-infoticker">
  <div class="owd-alert-carousel">
    <div class="owd-alert-carousel-icon">
      <img src="{info_yellow}" alt="インフォメーションアイコン">
    </div>
    <div class="owd-alert-carousel-item-wrap" style="min-width: 0;">
      <div class="splide" bind:this={splideElement}>
        <div class="splide__track">
          <ul class="splide__list">
            {#each newsToShow as news}
            <li class="owd-alert-carousel-item splide__slide">
              <a href={news.url} target="_blank" class="owd-alert-carousel-item-flex">
                <div class="owd-alert-carousel-item-textarea">
                  <p class="owd-caption category"><strong>{news.category}</strong></p>
                  <p class="owd-caption title"><strong>{news.title}</strong></p>
                </div>
              </a>
            </li>
            {/each}
          </ul>
        </div>
      </div>
      {#if newsToShow.length <= 0}
        <p class="owd-caption" style="color: white;"><strong>重要なお知らせはありません。</strong></p>
      {/if}
    </div>
    <div class="owd-alert-carousel-pagenation">
      <div class="owd-alert-carousel-pagenation-arrow">
        <button type="button" aria-label="前へ" onclick={() => splideInstance?.go('<')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12.8457 14.6551L8.19065 10.0001L12.8457 5.34508L11.6673 4.16675L5.83398 10.0001L11.6673 15.8334L12.8457 14.6551Z" fill="white"/>
          </svg>
        </button>
        <button type="button" aria-label="次へ" onclick={() => splideInstance?.go('>')}>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7.1543 14.6551L11.8093 10.0001L7.1543 5.34508L8.33263 4.16675L14.166 10.0001L8.33263 15.8334L7.1543 14.6551Z" fill="white"/>
          </svg>
        </button>
      </div>
      <div class="owd-alert-carousel-pagenation-num show:pc">
        {#if newsToShow.length > 0}
          <span class="owd-label:en">{currentIndex}&nbsp;/&nbsp;{newsToShow.length}</span>
        {:else}
          <span class="owd-label:en">0&nbsp;/&nbsp;{newsToShow.length}</span>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
.owd-infoticker {
  width: 100%;
  background-color: var(--primary-black);
  position: relative;
  z-index: 2;
  @include g.mobile {
    z-index: 100;
  }
  .owd-alert-carousel {
    width: 100%;
    padding: 8px 24px;
    display: grid;
    grid-template-columns: 24px 1fr 91px;
    gap: 8px;
    align-items: center;
    @include g.mobile {
      padding: 12px 24px;
      grid-template-columns: 24px 1fr 40px;
    }
    &-icon {
      width: 24px;
      height: 24px;
    }

    .splide-container {
      min-width: 0; /* gridアイテムがコンテンツ幅を超えないようにする */
    }

    &-item {
      a {
        text-decoration: none;
      }
      &-wrap{
        overflow: hidden;
      }
      &-flex {
        display: flex;
        width: 100%; /* 幅を100%に設定 */
        align-items: center;
      }
      &-textarea {
        display: flex;
        gap: 1rem;
        color: var(--primary-white); // テキスト色を白に
        width: 100%;
        min-width: 0; /* テキスト溢れ処理に必須 */
        flex-grow: 1;
        // @include g.hover-color( $bg-color: transparent,$color-after: var(--accent), $bg-color-after: transparent);
        .owd-caption {
          margin: 0;
          white-space: nowrap;      /* 折り返し禁止 */
          overflow: hidden;         /* はみ出しを隠す */
          text-overflow: ellipsis;  /* 溢れたら「...」にする */
          &.category {
            flex-shrink: 0;         /* カテゴリは縮めない */
          }
          &.title {
            flex-grow: 1;           /* タイトルが残りの幅を全て使う */
          }
        }
        transition: .2s;
        @media (hover: hover) {
            &:hover {
                color: var(--accent);
            }
          }
      }
    }
    &-pagenation {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      justify-self: end;

      &-arrow {
        display: flex;
        button {
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          width: 20px;
          height: 20px;
          transition: .2s;
          @media (hover: hover) {
            &:hover {
              background-color: var(--gray-v4);
              svg{
                path{
                  fill: var(--accent);
                }
              }
            }
          }
          // img {
          //   width: 100%;
          //   display: block;
          // }
        }
      }
      &-num {
        color: var(--primary-white);
        text-align: right;
      }
    }
  }
}
</style>